import React from "react";

const _toggleAriaHidden = boolean => {
  const els = document.querySelectorAll("header, #library");
  for (let i = 0; i < els.length; i++) {
    els[i].setAttribute("aria-hidden", boolean);
  }
};

const _setFocus = id => {
  const el = document.getElementById(id);
  el && el.focus();
};

/*
  Renders the manage sharing menu
    props:
    state:
*/
class OnBoarding extends React.Component {
  constructor() {
    super();
    this.state = {
      currentIndex: 0,
      unifyImageOffset: 1
    };

    this._handleKeyboard = this._handleKeyboard.bind(this);
    this._previousLevel = this._previousLevel.bind(this);
    this._nextLevel = this._nextLevel.bind(this);
    this._getLevelOnboarding = this._getLevelOnboarding.bind(this);
    this._skip = this._skip.bind(this);
    this._setLevel = this._setLevel.bind(this);
    this._touchStart = this._touchStart.bind(this);
    this._touchMove = this._touchMove.bind(this);
    this._touchEnd = this._touchEnd.bind(this);
  }

  componentDidMount() {
    window.addEventListener("keyup", this._handleKeyboard);
    _toggleAriaHidden(true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentIndex === this.props.levels.length) {
      Fraction.Helpers.removeModal(this.props.closeCallback);
      this._report("finish", "finishOnboarding");
    } else if (prevState.currentIndex < this.state.currentIndex) {
      this._report("next:click", "goNextOnboardingSlide");
      _setFocus(`dot-${this.state.currentIndex}`);
    } else if (prevState.currentIndex > this.state.currentIndex) {
      this._report("previous:click", "goPreviousOnboardingSlide");
      _setFocus(`dot-${this.state.currentIndex}`);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this._handleKeyboard);
  }

  _handleKeyboard(e) {
    e.stopPropagation();
    switch (e.keyCode) {
      case 37:
        this._previousLevel(e);
        break;
      case 39:
        this._nextLevel(e);
        break;
      default:
        break;
    }
  }

  _report(action, detail) {
    if (this.props.onboardingAnalytics) {
      Fraction.Reporter.gaEvent("V3/onboarding", action, detail);
    }
  }

  _touchStart(e) {
    if (!this.slideRight && !this.slideLeft) {
      e = Fraction.Helpers.normalEvent(e); // Normalize event
      this.moveCount = 0;
      this.setState({ downX: e.clientX });
    }
  }

  _touchMove(e) {
    e.stopPropagation();
    e.preventDefault();
    this.moveCount++;
    if (
      this.moveCount % 3 === 0 &&
      this.state.downX &&
      !this.slideLeft &&
      !this.slideRight
    ) {
      e = Fraction.Helpers.normalEvent(e); // Normalize event
      var movement = ((e.clientX - this.state.downX) / window.innerWidth) * 100;
      if (this.state.currentIndex === 0 && movement > 0) {
        return;
      }
      if (
        this.state.currentIndex === this.props.levels.length - 1 &&
        movement < 0
      ) {
        return;
      }
      this.onscreen.style.left = `${movement}%`;
      this.offscreenLeft.style.left = `${movement - 100}%`;
      this.offscreenRight.style.left = `${movement + 100}%`;
      if (movement < -25) {
        this.slideLeft = true;
        this._touchEnd();
      } else if (movement > 25) {
        this.slideRight = true;
        this._touchEnd();
      }
    }
  }

  _touchEnd(e) {
    this.setState({ downX: false });
    if (!this.processingTouchEnd) {
      this.processingTouchEnd = true;
      if (!this.slideLeft && !this.slideRight) {
        $(".onscreen").animate(
          {
            left: 0
          },
          100
        );
        $(".offscreenRight").animate(
          {
            left: "100%"
          },
          100
        );
        $(".offscreenLeft").animate(
          {
            left: "-100%"
          },
          100
        );
        this.processingTouchEnd = false;
      } else if (this.slideRight) {
        $(".onscreen").animate(
          {
            left: "100%"
          },
          100
        );
        $(".offscreenLeft").animate(
          {
            left: "0%"
          },
          100,
          function() {
            this._previousLevel();
            this.processingTouchEnd = false;
            this._resetTouchEvents();
          }.bind(this)
        );
      } else if (this.slideLeft) {
        $(".onscreen").animate(
          {
            left: "-100%"
          },
          100
        );
        $(".offscreenRight").animate(
          {
            left: "0%"
          },
          100,
          function() {
            this._nextLevel();
            this._resetTouchEvents();
          }.bind(this)
        );
      }
    }
  }

  _resetTouchEvents() {
    setTimeout(
      function() {
        this.slideLeft = false;
        this.slideRight = false;
        this.processingTouchEnd = false;
        this.onscreen.style.left = "0";
        this.offscreenLeft.style.left = "-100%";
        this.offscreenRight.style.left = "100%";
        this.setState({ unifyImageOffset: 1 });
      }.bind(this),
      250
    );
  }

  _nextLevel(e) {
    this.setState(prevState => {
      const currentIndex = prevState.currentIndex + 1;
      if (currentIndex <= this.props.levels.length) {
        return { currentIndex, unifyImageOffset: 0 };
      }
    });
  }

  _setLevel(level) {
    this.setState({
      currentIndex: level,
      unifyImageOffset: 0
    });
  }

  _skip(e) {
    Fraction.Helpers.removeModal(this.props.closeCallback);
    _setFocus("logo");
    _toggleAriaHidden(false);
    this._report("skip:click", "skipOnboarding");
  }

  _previousLevel(e) {
    this.setState(prevState => {
      if (prevState.currentIndex > 0) {
        const currentIndex = prevState.currentIndex - 1;
        return { currentIndex, unifyImageOffset: 0 };
      }
      return null;
    });
  }

  _skipButton() {
    let onClick,
      text,
      hidden = false;
    if (this.props.levels.length > 1) {
      if (!!(this.props.levels.length - this.state.currentIndex - 1)) {
        onClick = this._skip;
        text = i18n.t("base.skip");
      } else {
        hidden = true;
      }
    } else {
      onClick = this._nextLevel;
      i18n.t("base.close");
    }
    return (
      <div className="skip-onboarding-container">
        <button aria-hidden={hidden} onClick={onClick} className="noButton">
          <span className="skip-onboarding">{text}</span>
        </button>
      </div>
    );
  }

  _getLevelOnboarding(indexToRender) {
    if (this.props.levels[indexToRender]) {
      if (Fraction.Helpers.isSmallScreen()) {
        let description = this.props.levels[indexToRender].description;
        if (typeof description === "string") {
          description = <p>{description}</p>;
        }

        return (
          <div
            className="inner-onboarding-box upper"
            role="tabpanel"
            id={"tabpanel-0-" + indexToRender}
            aria-labelledby={"tab-0-" + indexToRender}
          >
            {this._skipButton()}
            {this.props.levels[indexToRender].title && (
              <h2 tabIndex="-1" className="modal-title">
                {this.props.levels[indexToRender].title}
              </h2>
            )}
            {this.props.levels[indexToRender].image && (
              <div className="onboarding-image">
                <img src={this.props.levels[indexToRender].image} alt="" />
              </div>
            )}
            {this.props.levels[indexToRender].description && (
              <div
                className="onboarding-description"
                style={{ bottom: Math.min(102, window.innerHeight - 400) }}
              >
                {description}
              </div>
            )}
            {this.props.levels[indexToRender].subDescription && (
              <div
                className="onboarding-description"
                style={{ bottom: Math.min(102, window.innerHeight - 400) }}
              >
                {this.props.levels[indexToRender].subDescription}
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div
            className="inner-onboarding-box"
            role="tabpanel"
            id={"tabpanel-0-" + indexToRender}
            aria-labelledby={"tab-0-" + indexToRender}
          >
            {this.props.levels[indexToRender].title && (
              <h2 tabIndex="-1" className="modal-title">
                {this.props.levels[indexToRender].title}
              </h2>
            )}
            {this.props.levels[indexToRender].image && (
              <div className="onboarding-image">
                <img src={this.props.levels[indexToRender].image} alt="" />
              </div>
            )}
            {this.props.levels[indexToRender].description && (
              <div className="onboarding-description">
                {this.props.levels[indexToRender].description}
              </div>
            )}
            {this.props.levels[indexToRender].subDescription && (
              <div className="onboarding-description">
                {this.props.levels[indexToRender].subDescription}
              </div>
            )}
          </div>
        );
      }
    }
  }

  _navigation() {
    if (this.props.levels.length > 1) {
      const dots = this.props.levels.map((dot, index) => {
        const style = {};
        if (index === this.state.currentIndex) {
          style.background = "#FFFFFF";
        } else {
          style.background = "rgba(255,255,255,0.30)";
        }
        return (
          <li role="tab">
            <button
              className="noButton dot"
              id={`dot-${index}`}
              key={`dot-${index}`}
              style={style}
              onClick={() => this._setLevel(index)}
            />
          </li>
        );
      });
      return (
        <ul className="navigation" role="tablist">
          {dots}
        </ul>
      );
    }
  }

  _nextButton() {
    return (
      <div className="flex-item">
        <button
          className="noButton next-button nav-button"
          onClick={this._nextLevel}
        >
          {this.state.currentIndex < this.props.levels.length - 1
            ? i18n.t("base.next").capitalize()
            : i18n.t("base.done").capitalize()}
        </button>
      </div>
    );
  }

  _previousButton() {
    if (this.state.currentIndex > 0) {
      return (
        <div className="flex-item">
          <button
            className="noButton previous-button nav-button flex-item"
            onClick={this._previousLevel}
          >
            {i18n.t("base.previous")}
          </button>
        </div>
      );
    } else {
      return <div className="flex-item" />;
    }
  }

  render() {
    var onboardingLevels = this.props.levels;
    var indexToRender = this.state.currentIndex;
    if (Fraction.Helpers.isSmallScreen()) {
      return (
        <div className="onboarding">
          <div
            ref={osl => {
              this.offscreenLeft = osl;
            }}
            className="offscreenLeft"
            aria-hidden={true}
          >
            {this._getLevelOnboarding(
              indexToRender - this.state.unifyImageOffset
            )}
          </div>
          <div
            ref={os => {
              this.onscreen = os;
            }}
            className="onscreen"
            onTouchMove={this._touchMove}
            onTouchStart={this._touchStart}
            onTouchEnd={this._touchEnd}
          >
            {this._getLevelOnboarding(indexToRender)}
          </div>
          <div
            ref={osr => {
              this.offscreenRight = osr;
            }}
            className="offscreenRight"
            aria-hidden={true}
          >
            {this._getLevelOnboarding(
              indexToRender + this.state.unifyImageOffset
            )}
          </div>
          <div className="onboarding-footer">
            {this._previousButton()}
            {this._navigation()}
            {this._nextButton()}
          </div>
        </div>
      );
    } else {
      return (
        <div className="onboarding">
          <div
            ref={osl => {
              this.offscreenLeft = osl;
            }}
            className="offscreenLeft"
            aria-hidden={true}
          >
            {this._getLevelOnboarding(
              indexToRender - this.state.unifyImageOffset
            )}
          </div>
          <div
            ref={os => {
              this.onscreen = os;
            }}
            className="onscreen"
            onTouchMove={this._touchMove}
            onTouchStart={this._touchStart}
            onTouchEnd={this._touchEnd}
          >
            {this._getLevelOnboarding(indexToRender)}
          </div>
          <div
            ref={osr => {
              this.offscreenRight = osr;
            }}
            className="offscreenRight"
            aria-hidden={true}
          >
            {this._getLevelOnboarding(
              indexToRender + this.state.unifyImageOffset
            )}
          </div>
          {onboardingLevels.length > 1 && (
            <div className="onboarding-footer">
              <ul
                className="navigation"
                role="tablist"
                style={{ width: onboardingLevels.length * 24 }}
              >
                {onboardingLevels.map((level, index) => (
                  <li role="tab">
                    <button
                      id={`dot-${index}`}
                      onClick={() => this._setLevel(index)}
                      className={`noButton dot ${
                        indexToRender === index ? "active" : ""
                      }`}
                    >
                      <span className="offScreen">
                        {i18n.t("onboarding.slide")} {index}
                      </span>
                    </button>
                  </li>
                ))}

                {indexToRender > 0 && (
                  <button
                    className="noButton previous-button nav-button"
                    onClick={this._previousLevel}
                  >
                    {i18n.t("base.previous")}
                  </button>
                )}
                <button
                  className="noButton next-button nav-button"
                  onClick={this._nextLevel}
                >
                  {indexToRender < onboardingLevels.length - 1
                    ? i18n.t("base.next").capitalize()
                    : i18n.t("base.done").capitalize()}
                </button>
              </ul>
            </div>
          )}
        </div>
      );
    }
  }
}

var OnBoardingHelper = {
  _showOnboardingModal: function(
    identifier,
    container,
    refocusDOM,
    closeCallback,
    forceFinish
  ) {
    Fraction.Helpers.showModal(
      {
        title: false,
        menuId: identifier,
        content: container,
        closeCallback: closeCallback,
        buttons: [],
        hideCloseButton: forceFinish,
        noOuterClick: forceFinish,
        fullscreen: true,
        width: 400,
        height: 368,
        definingClass: "onboarding-modal " + identifier,
        intersitial: Fraction.Helpers.isSmallScreen()
      },
      refocusDOM,
      false
    );
  },

  _onboarding: function(refocusDOM, force) {
    if (
      Fraction.Brand.Onboarding.enabled ||
      (Fraction.Brand.Onboarding.custom &&
        Fraction.Brand.Onboarding.custom.filter(card => card.enabled).length >
          0)
    ) {
      // Why do we need a timeout?  Because fraction will redirect
      // if not signed in and proactively use it's onboarding :'(
      const onboardingTimeout = setTimeout(
        function() {
          Fraction.Helpers.getUser(
            function() {
              if (Fraction.User) {
                var sameUser =
                  Fraction.Helpers.getItem("_lastOnboarding") ===
                  Fraction.User.email.hashMe().toString();

                // "force" is a parameter sent to function, "hasBrandedForce" is a flag to see
                // if the brand is set to force show a custom message on every sign in
                // Also note we just check the first custom item for the "force" option, which
                // will have to change if we add more than one custom message
                var hasBrandedForce = Fraction.Brand.Onboarding.custom.some(
                  brand => brand.force
                );

                // Check local storage to see if we've shown yet for this session.
                // If not, set it so it's not shown until a new session is created
                var brandingForce;
                var hashedSession = Fraction.User.sessionId.hashMe().toString();
                if (
                  hasBrandedForce &&
                  Fraction.Helpers.getItem("customMessageHash") !==
                    hashedSession
                ) {
                  brandingForce = true;
                  Fraction.Helpers.setItem("customMessageHash", hashedSession);
                } else {
                  brandingForce = false;
                }
                const onboarding =
                  Fraction.Helpers.getUserData("onboarding") || {};
                if (!onboarding["welcome"] || force || brandingForce) {
                  this._showOnboardingModal(
                    "onboarding",
                    <OnBoarding
                      key="onboardingModal"
                      levels={this._getOnboardingLevels(sameUser)}
                      onboardingAnalytics={true}
                      showDownloads={true}
                    />,
                    refocusDOM,
                    function() {
                      _setFocus("logo");
                      _toggleAriaHidden(false);
                      Fraction.Reporter.gaEvent(
                        "V3/onboarding",
                        "close",
                        "onboardingClosed"
                      );
                    },
                    Fraction.Brand.Onboarding.forceFinish
                  );
                  onboarding.welcome = Fraction.User.sessionId;
                  Fraction.Helpers.saveUserData("onboarding", onboarding);
                  Fraction.Reporter.gaEvent(
                    "V3/onboarding",
                    "show",
                    "onboardingOpened"
                  );
                }
              }
            }.bind(this)
          );
        }.bind(this),
        1400
      );
      return onboardingTimeout;
    }
  },

  _newOnboarding(id, levels, callback, refocusDOM, showDownloads) {
    this._showOnboardingModal(
      id,
      <OnBoarding
        key={`${id}-modal`}
        levels={levels}
        showDownloads={showDownloads}
        closeCallback={callback}
      />,
      refocusDOM,
      function() {}
    );
  },

  _sharingOnboarding(refocusDOM, scenario = "news", force) {
    const onboarding = Fraction.Helpers.getUserData("onboarding");
    if (
      !onboarding ||
      (onboarding.welcome === Fraction.User.sessionId && !force)
    ) {
      return;
    }
    const levels = {
      news: this._getSharingAllUsersLevels(),
      student: this._getSharingStudentsLevels(),
      educator: this._getSharingEducatorLevels()
    };

    if (scenario === "educator" && (!onboarding[scenario] || force)) {
      Fraction.Helpers.removeModal(() => {
        Fraction.Helpers.showModal(
          {
            title: i18n.t("onboarding.groups.connect-with-students"),
            content: (
              <span>{i18n.t("onboarding.groups.students-can-see-all")}</span>
            ),
            buttons: [
              {
                label: i18n.t("base.not-now"),
                color: "linkGray",
                click: Fraction.Helpers.removeModal
              },
              {
                label: i18n.t("base.continue"),
                click: () => {
                  this._startSharingOnboarding(
                    levels[scenario],
                    refocusDOM,
                    force
                  );
                  onboarding[scenario] = Fraction.User.sessionId;
                  Fraction.Helpers.saveUserData("onboarding", onboarding);
                }
              }
            ],
            intersitial: Fraction.Helpers.isSmallScreen()
          },
          refocusDOM,
          false
        );
      });
    } else {
      if (!onboarding[scenario] || force) {
        this._startSharingOnboarding(levels[scenario], refocusDOM, force);
        onboarding[scenario] = Fraction.User.sessionId;
        Fraction.Helpers.saveUserData("onboarding", onboarding);
      }
    }
  },

  _startSharingOnboarding(levels, refocusDOM, force) {
    Fraction.Helpers.removeModal(() => {
      setTimeout(
        () =>
          this._showOnboardingModal(
            "onboarding",
            <OnBoarding
              key="onboardingModal"
              levels={levels}
              onboardingAnalytics
            />,
            refocusDOM,
            () => {
              _setFocus("logo");
              _toggleAriaHidden(false);
              Fraction.Reporter.gaEvent(
                "V3/onboarding",
                "close",
                "onboardingClosed"
              );
            }
          ),
        100
      );
    });
  },

  _starReader: function(refocusDOM, callback) {
    this._newOnboarding(
      "star-reader",
      this._getStarUserLevels(callback),
      callback,
      refocusDOM
    );
  },

  _labsOnboarding: function(refocusDOM, callback) {
    this._newOnboarding(
      "labs-onboarding",
      this._getLabsLevels(),
      callback,
      refocusDOM
    );
  },

  _getStarUserLevels: function(callback) {
    var tryItOut = function() {
      Fraction.Helpers.Labs.enableLab("review-mode").then(function() {
        Fraction.Helpers.Modals.removeModal(callback);
      });
    };
    var remindMeLater = function() {
      Fraction.Helpers.Modals.removeModal();
    };
    var dontShowAgain = function() {
      Fraction.Helpers.Users.saveUserData("onboarding.seen-labs-invite", true);
      Fraction.Helpers.Modals.removeModal();
    };
    return [
      {
        title: i18n.t("review-mode.star-student"),
        image: "/img/watkins_star.svg",
        description: (
          <span>
            {toHTML(i18n.t("review-mode.star-student-description"))}
            {this._onboardingOptions({
              main: { title: i18n.t("labs.try-it-out"), callback: tryItOut },
              left: {
                title: i18n.t("base.dont-show-again"),
                callback: dontShowAgain
              },
              right: {
                title: i18n.t("base.remind-me-later"),
                callback: remindMeLater
              }
            })}
          </span>
        )
      }
    ];
  },

  _getLabsLevels: function() {
    return [
      {
        title: i18n.t("labs.welcome"),
        image: "/img/onboarding_labs.svg",
        description: i18n.t("labs.labs-description")
      },
      {
        title: i18n.t("labs.check-it-out"),
        image: Fraction.Helpers.isSmallScreen()
          ? "/img/onboarding_labs_panel_mobile.svg"
          : "/img/onboarding_labs_panel.svg",
        description: i18n.t("labs.more-description")
      }
    ];
  },

  _getSharingAllUsersLevels() {
    return [
      {
        title: i18n.t("onboarding.groups.explore-whats-new"),
        image: "/img/onboarding-allusers1.png",
        description: i18n.t("onboarding.groups.check-reading-assignments")
      },
      {
        title: i18n.t("onboarding.groups.highlighter-updates"),
        image: "/img/onboarding-allusers2.png",
        description: i18n.t("onboarding.groups.check-highlighters")
      },
      {
        title: i18n.t("onboarding.groups.sharing"),
        image: "/img/onboarding-allusers3.png",
        description: i18n.t("onboarding.groups.custom-links")
      },
      {
        title: i18n.t("onboarding.groups.reading-assignments"),
        image: "/img/onboarding-allusers4.png",
        description: i18n.t("onboarding.groups.focused-readings")
      }
    ];
  },

  _getSharingStudentsLevels() {
    return [
      {
        title: i18n.t("onboarding.groups.class-network"),
        image: "/img/onboarding-students1.png",
        description: i18n.t("onboarding.groups.connect-professor")
      },
      {
        title: i18n.t("onboarding.groups.shared-highlighters"),
        image: "/img/onboarding-students2.png",
        description: i18n.t("onboarding.groups.professors-highlighters")
      },
      {
        title: i18n.t("onboarding.groups.reading-assignments"),
        image: "/img/onboarding-students3.png",
        description: i18n.t("onboarding.groups.view-readings")
      },
      {
        title: i18n.t("onboarding.groups.sharing-with-friends"),
        image: "/img/onboarding-students4.png",
        description: i18n.t("onboarding.groups.custom-links")
      }
    ];
  },

  _getSharingEducatorLevels() {
    return [
      {
        title: i18n.t("onboarding.groups.shared-highlighters"),
        image: "/img/onboarding-educator1.png",
        description: i18n.t("onboarding.groups.students-highlighters")
      },
      {
        title: i18n.t("onboarding.groups.reading-assignments"),
        image: "/img/onboarding-educator2.png",
        description: i18n.t("onboarding.groups.students-focused-readings")
      },
      {
        title: i18n.t("onboarding.groups.sharing-with-colleagues"),
        image: "/img/onboarding-educator3.png",
        description: i18n.t("onboarding.groups.custom-links")
      }
    ];
  },

  _getSharingOnboardingLevels() {
    return [
      {
        title: i18n.t("onboarding.groups.add-followers"),
        image: "/img/onboarding-sharing1.png",
        description: i18n.t("onboarding.groups.custom-link")
      },
      {
        title: i18n.t("onboarding.groups.create-public-highlighter"),
        image: "/img/onboarding-sharing2.png",
        description: i18n.t("onboarding.groups.highlighters-share")
      },
      {
        title: i18n.t("onboarding.groups.followers"),
        image: "/img/onboarding-sharing3.png",
        description: i18n.t("onboarding.groups.highlighters-following")
      }
    ];
  },

  _getOnboardingLevels: function(downloadOnly) {
    var levels = [];
    if (!downloadOnly) {
      levels = levels.concat([
        {
          title: i18n.t("onboarding.introducing-bookshelf", {
            brand: Fraction.Brand.brand
          }),
          image: "/img/onboarding_devices_large.png",
          description: i18n.t("onboarding.redesigned-bookshelf", {
            brand: Fraction.Brand.brand
          })
        },
        {
          title: i18n.t("onboarding.find-books-quick"),
          image: "/img/onboarding_filter_large.png",
          description: i18n.t("onboarding.enjoy-all-books")
        },
        {
          title: i18n.t("onboarding.sharing"),
          image: "/img/onboarding_sharing_large.png",
          description: i18n.t("onboarding.exchange-notes-highlights")
        },
        {
          title: i18n.t("onboarding.customize"),
          image: "/img/onboarding_panels_large.png",
          description: i18n.t("onboarding.customize-panels")
        }
      ]);
    }
    if (
      !Fraction.Brand.AccountCompletion.ssoOnly &&
      !Fraction.User.ssoOnly &&
      Fraction.Brand.Onboarding.downloadPage
    ) {
      levels.push({
        title: i18n.t("onboarding.read-offline"),
        image: "/img/onboarding_apps_large.png",
        description: Fraction.User.ssoOnly
          ? window.toHTML(i18n.t("onboarding.mobile-downloads-no-link"))
          : window.toHTML(
              i18n.t("onboarding.mobile-downloads", {
                brand: Fraction.Helpers.isBookshelfBrand()
                  ? "Bookshelf"
                  : Fraction.Brand.brand,
                ios: "https://itunes.apple.com/us/app/bookshelf/id389359495",
                android:
                  "https://play.google.com/store/apps/details?id=com.vitalsource.bookshelf",
                mac:
                  "https://support.vitalsource.com/hc/en-us/articles/201950773",
                pc:
                  "https://support.vitalsource.com/hc/en-us/articles/201067238"
              })
            )
      });
    }

    // If brand is set to disable default onboarding modals, empty the array
    if (!Fraction.Brand.Onboarding.enabled) {
      levels = [];
    }

    Fraction.Brand.Onboarding.custom.forEach(customSlide => {
      // If not enabled, skip over
      if (!customSlide.enabled) {
        return true;
      }

      // Otherwise, push new level to array
      levels.push({
        title: customSlide.title,
        image: customSlide.image,
        description: toHTML(customSlide.description),
        subDescription: toHTML(customSlide.subDescription)
      });
    });

    return levels;
  },

  /*
    {
      main: {title: "Main Button", callback: <main callback>},
      left: {title: "Left Button", callback: <left callback>},
      right: {title: "Right Button", callback: <right callback>}
    }
  */
  _onboardingOptions: function(options) {
    return (
      <div className="onboarding-options">
        <button onClick={options.main.callback} className="submit">
          {options.main.title}
        </button>
        <button onClick={options.left.callback} className="noButton">
          {options.left.title}
        </button>
        <button onClick={options.right.callback} className="noButton">
          {options.right.title}
        </button>
      </div>
    );
  }
};

export { OnBoarding, OnBoardingHelper };
